import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import * as constants from './constants/AppConstants';

export function sendSubscription(subscription) {
  const userDetails = JSON.parse(window.localStorage.getItem('userDetails'));
  const userId = userDetails.userName;
  const orgId = get(userDetails, 'organization.id', '');
  if (!isEmpty(userId) && !isEmpty(orgId)) {
    const url = `${constants.PUSH_NOTIFS_URL}/users/${userId}/preferences/notifications`;
    const body = {
      userID: userId,
      applicationID: 'default',
      organizationID: orgId,
      subscriptionPreference: {
        type: constants.NOTIFICATION_TYPE.WebPush,
        meta: subscription,
      },
    };
    return fetch(url, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
  return null;
}

export const getVapidKey = async () => {
  const userDetails = JSON.parse(window.localStorage.getItem('userDetails'));
  const orgId = get(userDetails, 'organization.id', '');
  const notificationType = 'webpush';
  if (!isEmpty(orgId)) {
    const url = `${constants.PUSH_NOTIFS_URL}/organizations/${orgId}/preferences/notifications/${notificationType}/info`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const vapidKeyResponse = await response.json();
      const vapidKey = get(vapidKeyResponse, 'subscriptionInfo.publicKey', '');
      return vapidKey;
    } catch (e) {
      console.error('An error ocurred during fetching vapid key.', e);
      return null;
    }
  } else {
    return null;
  }
};

export const handleExistedSubscription = (registration, vapidKey, existedSubscription) => {
  if (existedSubscription === null && !isEmpty(vapidKey)) {
    console.log('No subscription detected, make a request.');
    registration.pushManager
      .subscribe({
        applicationServerKey: vapidKey,
        userVisibleOnly: true,
      })
      .then((newSubscription) => {
        console.log('New subscription added.');
        sendSubscription(newSubscription);
      })
      .catch((e) => {
        if (Notification.permission !== 'granted') {
          console.log('Permission was not granted.');
        } else {
          console.error('An error ocurred during the subscription process.', e);
        }
      });
  } else {
    console.log('Existed subscription detected.');
    sendSubscription(existedSubscription);
  }
};

export const subscribeForNotifications = async () => {
  const vapidKey = await getVapidKey();
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        if (!registration.pushManager) {
          console.log('Push manager unavailable.');
          return;
        }
        registration.pushManager.getSubscription().then((existedSubscription) => {
          handleExistedSubscription(registration, vapidKey, existedSubscription);
        });
      })
      .catch((e) => {
        console.error('An error ocurred during Service Worker registration.', e);
      });
  }
};

export function register() {
  const userDetails = JSON.parse(window.localStorage.getItem('userDetails'));
  const token = JSON.parse(window.localStorage.getItem('token'));
  const authToken = (token && token.access_token) || '';
  if (authToken && userDetails) {
    subscribeForNotifications();
  } else {
    window.onstorage = () => {
      register();
    };
  }
}

export function validateAndRegister() {
  if (constants.IS_PUSH_NOTIFS_ENABLED === 'YES') {
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        console.log('User granted permisions for push notifications');
        register();
      }
    });
  }
}

export default {};
